import { ResultRouter, createBoundRouter } from '@acsbe/routing';
import pages from '../pages';
import { RouterContext, useRouterContext } from './context';

export const Router: ResultRouter<RouterContext> = createBoundRouter(
  pages,
  useRouterContext,
);
